export default __webpack_public_path__ + "src/shared/svg/providers/d0d6c01837c80608809f926103d7bfdf.png";